// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2hLSB","productName":"Table_productName__1jPTW"};